import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { useQuery } from 'data-fetching-client';
import { GET_THREAD_ATTACHMENTS_QUERY, GET_THREAD_ATTACHMENTS_QUERY_FIELD_NAME } from 'customer-portal-app/__generated__/chirp/com/hubspot/support/portal/rpc/AttachmentsRpc.dfc.new';
import { getIsPreview } from '../utils/isPreview';
import { getPreviewThreadAttachments } from './previewMocks';
export { GET_THREAD_ATTACHMENTS_QUERY, GET_THREAD_ATTACHMENTS_QUERY_FIELD_NAME };
export const useThreadAttachments = (ticketId, threadId) => {
  const {
    isPreview
  } = getIsPreview();
  const _useQuery = useQuery(GET_THREAD_ATTACHMENTS_QUERY, {
      variables: {
        params: {
          ticketId,
          threadId: threadId
        }
      },
      skip: isPreview || !ticketId || threadId === undefined
    }),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  if (isPreview) {
    return Object.assign({
      data: getPreviewThreadAttachments(),
      loading: false,
      refetch
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result,
    loading,
    refetch
  }, rest);
};